import React, { useState } from 'react';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import { ButtonCancel, ButtonPrimary } from '../../../../utils/Button';
import FocusControl from '../../../../utils/FocusControl';
import InputField, {
    InputCheckbox,
    SelectOption,
    TextareaField,
    addOption
} from '../../../../utils/InputField';
import { ApiCreateService } from '../ServiceOperation';
import { useServices } from '../ServicesProvider';

function AddServiceModal({ setAddServiceModal }) {
    const { setMessage } = useTemplate();
    const { setReloadKey } = useServices();
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        ServiceTitle: '',
        Description: '',
        IsDuration: false,
        Status: 'active'
    });

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === 'IsDuration') {
            setFormData((d) => ({ ...d, [name]: !formData.IsDuration }));
            return;
        }

        setFormData((d) => ({ ...d, [name]: value }));
    };

    const handleAddService = (e) => {
        setLoading(true);
        e.preventDefault();
        ApiCreateService(formData, setIsError)
            .then(({ title }) => {
                setLoading(false);
                setMessage({ type: 'success', text: title });
                setAddServiceModal(false);
                setReloadKey((d) => d + 1);
            })
            .catch((error) => {
                setLoading(false);
                setMessage({ type: 'error', text: error.toString(0) });
            });
    };
    FocusControl(isError, setIsError, formData);
    return (
        <form onSubmit={handleAddService} className="flex flex-col gap-4">
            <InputField
                label="Service Title"
                placeholder='eg: "Installation", "Maintenance", "Management", "Backup"'
                name="ServiceTitle"
                formData={formData}
                onChange={handleChange}
            />
            <TextareaField
                label="Description"
                name="Description"
                formData={formData}
                onChange={handleChange}
                placeholder="Enter a short description of the service"
                height="h-32"
            />
            <SelectOption
                label="Status"
                name="Status"
                formData={formData}
                onChange={handleChange}
                options={['Active', 'Inactive'].map((d) => addOption(d, d, d.toLowerCase()))}
            />

            <InputCheckbox
                label="IsDuration"
                name="IsDuration"
                formData={formData}
                onChange={handleChange}
                text="Is this service duration based?"
            />

            <div className="w-full flex justify-end items-center gap-2 mb-2">
                <ButtonCancel title="Cancel" onClick={() => setAddServiceModal(false)} />
                <ButtonPrimary title="Save" btnType="submit" loading={loading} />
            </div>
        </form>
    );
}

export default AddServiceModal;
